<template>
  <div>
    <h1 class="text-pagename text-xs-center">Set Notification App</h1>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap justify-center>
        <v-flex xs12 md6 class="mb-3">
          <h3 style="padding-left: 20px; padding-bottom: 10px">
            Create Notification Form
          </h3>
          <v-card class="mx-3 px-2 pb-1" flat style="border: 2px solid #f2f2f2">
            <v-layout row wrap class="px-4">
              <v-flex xs12>
                <v-text-field
                  :disabled="isEditNotificaion"
                  label="Title"
                  v-model="form.notification_inbox_title"
                  hide-details
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  :disabled="isEditNotificaion"
                  label="Description"
                  v-model="form.notification_inbox_text"
                  hide-details
                  :rules="[rules.required]"
                ></v-text-field>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12>
                <v-radio-group
                  :disabled="isEditNotificaion"
                  v-model="form.notification_is_all_province"
                  :mandatory="false"
                  row
                  hide-details
                >
                  <v-radio
                    color="primary"
                    label="All Province"
                    :value="true"
                    class="pb-2"
                  ></v-radio>
                  <v-radio
                    color="primary"
                    label="Select Province"
                    :value="false"
                    class="pb-2"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :disabled="isEditNotificaion"
                  multiple
                  clearable
                  label="Choose provinces are you want to send notification"
                  v-model="form.notification_inbox_province"
                  chips
                  :items="provinceData"
                  item-text="province_name_en"
                  item-value="province_id"
                  v-if="form.notification_is_all_province == false"
                  :rules="[
                    (v) =>
                      (form.notification_inbox_province.length > 0 &&
                        form.notification_inbox_province[0] != 0) ||
                      'Province is required',
                  ]"
                ></v-select>
              </v-flex>
              <v-flex
                xs12
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <v-btn
                  style="width: 100%; height: 50px"
                  outline
                  color="#50b0f6"
                  @click="toWriteBlog()"
                  :disabled="isEditNotificaion"
                  v-if="
                    form.notification_inbox_html == '' ||
                    form.notification_inbox_html == null
                  "
                >
                  <h3>CREATE NEW BLOG</h3>
                </v-btn>
                <v-btn
                  dark
                  style="width: 100%; height: 50px"
                  color="#50b0f6"
                  @click="toWriteBlog()"
                  :disabled="isEditNotificaion"
                  v-else
                >
                  <h3>VIEW/EDIT BLOG</h3>
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                class="text-xs-center pb-4 pt-4"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <v-btn
                  :disabled="is_sending || isEditNotificaion"
                  color="#f2f2f2"
                  @click="clearForm()"
                  slot="activator"
                  style="height: 30px"
                >
                  <h3 style="color: #9e9e9e; font-size: 14px">CLEAR</h3>
                </v-btn>
                <v-btn
                  :disabled="isEditNotificaion"
                  color="#fddf00"
                  @click="send(form)"
                  :loading="is_sending"
                  slot="activator"
                  style="height: 30px"
                >
                  <h3 style="font-size: 14px">SEND</h3>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 class="pl-3 pb-3">
          <h3 style="padding-bottom: 10px">Sample</h3>
          <v-card style="overflow: hidden; border: 2px solid #f2f2f2" flat>
            <v-layout row wrap justify-center align-center>
              <v-flex xs9 class="py-2 pt-2">
                <div class="mb-1">
                  <img src="@/assets/back-office/logo2.png" width="12px" />
                  &nbsp; WESERVE - Now
                </div>
                <div>
                  {{
                    form.notification_inbox_title
                      ? form.notification_inbox_title
                      : "Notification title"
                  }}
                </div>
                <span style="color: #757575">
                  {{
                    form.notification_inbox_text
                      ? form.notification_inbox_text
                      : "Description"
                  }}
                </span>
              </v-flex>
              <v-flex xs2 class="text-xs-center mt-2">
                <!-- <img src="@/assets/back-office/logo2.png" style="width:50px;"> -->
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <div>
      <h3 style="padding-left: 20px; padding-bottom: 10px">
        Notification Blog Management
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="isLoading"
          class="pl-2"
        ></v-progress-circular>
      </h3>
      <v-card
        class="mx-3 pa-2 mb-2"
        style="position: relative"
        v-for="(info, index) in notification_list"
        :key="index"
      >
        <v-layout row wrap justify-center align-center>
          <v-flex xs12 sm6 lg4 class="pb-2">
            <v-card
              flat
              color="#f2f2f2"
              style="border-radius: 15px; min-width: 250px; max-width: 300px"
            >
              <v-layout row wrap justify-center align-center>
                <v-flex xs9 class="py-2 pt-2">
                  <div class="mb-1">
                    <img src="@/assets/back-office/logo2.png" width="12px" />
                    &nbsp; WESERVE - Now
                  </div>
                  <div>{{ info.notification_inbox_title }}</div>
                  <span style="color: #757575">
                    {{ info.notification_inbox_text }}
                  </span>
                </v-flex>
                <v-flex xs2 class="text-xs-center mt-2">
                  <v-btn
                    icon
                    @click="toEditNotification(info)"
                    v-if="info.notification_inbox_saved == true"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm2 lg4 class="pb-1">
            <v-card
              flat
              color="#f2f2f2"
              class="pa-2"
              style="border-radius: 15px; max-width: 300px"
            >
              Province
              <ul>
                <li
                  v-for="(provinceID, i) in info.notification_inbox_province"
                  :key="i"
                >
                  {{ provinceID == 0 ? "All" : checkProvince(provinceID) }}
                </li>
              </ul>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 lg4 class="text-xs-center">
            <v-btn
              :disabled="isEditNotificaion"
              round
              dark
              :loading="isEditingBlog"
              v-if="info.notification_inbox_saved == true"
              @click="toEditBlog(info)"
              >View/Edit Blog</v-btn
            >
            <v-tooltip top>
              <v-btn
                icon
                @click="resend(info)"
                :disabled="is_sending || isEditNotificaion"
                :loading="is_sending"
                slot="activator"
              >
                <v-icon medium>send</v-icon>
              </v-btn>
              <span>Resend</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-btn
          icon
          style="position: absolute; top: 3px; right: 3px"
          @click="deleteNotificationLog(info)"
          :disabled="is_deleting || isEditNotificaion"
          :loading="is_deleting"
          v-if="info.notification_inbox_saved == false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card>
    </div>
    <v-dialog persistent v-model="editContentDialog" max-width="600px">
      <v-card>
        <v-toolbar flat dark>
          <v-toolbar-title>Edit Title and Description</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-text-field
            :disabled="isEditNotificaion"
            label="Title"
            v-model="selectedItem.notification_inbox_title"
            hide-details
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
            :disabled="isEditNotificaion"
            label="Description"
            v-model="selectedItem.notification_inbox_text"
            hide-details
            :rules="[rules.required]"
          ></v-text-field>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            :disabled="isEditingContent"
            @click="editContentDialog = false"
            >Close</v-btn
          >
          <v-btn flat :loading="isEditingContent" @click="editContent()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="editSnackbar"
      :bottom="null"
      :top="true"
      :right="null"
      :left="null"
      :multi-line="false"
      :timeout="3000"
      :vertical="false"
    >
      <span v-if="resultEdit">
        <v-icon color="success">check</v-icon>Edit blog successfully
      </span>
      <span v-else> <v-icon color="error">close</v-icon>Can't edit blog </span>
    </v-snackbar>
    <EditorDialog
      v-model="form.notification_inbox_html"
      :dialog="openEditorDialog"
      @closeDialog="openEditorDialog = false"
    />
    <EditorDialog
      v-model="selectedItem.notification_inbox_html"
      :dialog="editEditorDialog"
      @save="editBlog()"
      @closeDialog="editEditorDialog = false"
    />
  </div>
</template>

<script>
import EditorDialog from "@/components/back-office/SetAppNotification/EditorDialog.vue";
import ViewDialog from "@/components/back-office/SetAppNotification/ViewDialog.vue";
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    isEditingBlog: false,
    selectedItem: {
      notification_inbox_id: null,
      notification_inbox_text: "",
      notification_inbox_title: "",
      notification_inbox_html: "",
    },
    editEditorDialog: false,
    editContentDialog: false,
    openEditorDialog: false,
    is_sending: false,
    is_deleting: false,
    form: {
      notification_inbox_title: "",
      notification_inbox_text: "",
      notification_inbox_province: [],
      notification_inbox_saved: false,
      notification_inbox_html: "",
      notification_is_all_province: true,
    },
    valid: true,
    rules: {
      required: (value) => !!value || "Required.",
    },
    resultEdit: false,
    editSnackbar: false,
    isLoading: false,
    isEditingContent: false,
  }),
  components: {
    EditorDialog,
    ViewDialog,
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      notification_list: (state) => state.fetchFoodSetAppBack.notification_list,
    }),
    ...mapGetters({
      isEditNotificaion: "isEditNotificaion",
    }),
  },
  methods: {
    clearForm() {
      this.setForm();
      this.$refs.form.resetValidation();
    },
    toEditNotification(info) {
      this.selectedItem = JSON.parse(JSON.stringify(info));
      this.editContentDialog = true;
    },
    checkProvince(province_id) {
      if (this.provinceData.length > 0) {
        let province = this.provinceData.find(
          (val) => val.province_id == province_id
        );
        return (province && province.province_name_en) || null;
      } else {
        return null;
      }
    },
    toWriteBlog() {
      this.openEditorDialog = true;
    },
    toEditBlog(info) {
      let clone_obj = JSON.parse(JSON.stringify(info));
      this.editEditorDialog = true;
      this.selectedItem = clone_obj;
    },
    async deleteNotificationLog(info) {
      this.is_deleting = true;
      await this.$store.dispatch(
        "fetchFoodSetAppBack/deleteNotificationLog",
        info.notification_inbox_id
      );
      this.is_deleting = false;
    },
    async editContent() {
      this.isEditingContent = true;
      let form = {
        notification_inbox_id: this.selectedItem.notification_inbox_id,
        notification_inbox_title: this.selectedItem.notification_inbox_title,
      };
      this.resultEdit = await this.$store.dispatch(
        "fetchFoodSetAppBack/editNotificationContent",
        form
      );
      if (this.resultEdit == true) {
        this.editContentDialog = false;
        this.fetchData();
        this.setFormSelect();
      }
      this.editSnackbar = true;
      this.isEditingContent = false;
    },
    async editBlog() {
      this.isEditingBlog = true;
      let form = {
        notification_inbox_id: this.selectedItem.notification_inbox_id,
        notification_inbox_html: this.selectedItem.notification_inbox_html,
      };
      this.resultEdit = await this.$store.dispatch(
        "fetchFoodSetAppBack/editNotificationBlog",
        form
      );
      if (this.resultEdit == true) {
        this.fetchData();
        this.setFormSelect();
      }
      this.editSnackbar = true;
      this.isEditingBlog = false;
    },
    setFormSelect() {
      this.selectedItem = {
        notification_inbox_id: null,
        notification_inbox_text: "",
        notification_inbox_title: "",
        notification_inbox_html: "",
      };
    },
    setForm() {
      this.form = {
        notification_inbox_title: "",
        notification_inbox_text: "",
        notification_inbox_province: [],
        notification_inbox_saved: false,
        notification_inbox_html: "",
        notification_is_all_province: true,
      };
    },
    async resend(send_form) {
      let clone_obj = JSON.parse(JSON.stringify(send_form));
      if (
        clone_obj.notification_inbox_province.length > 0 &&
        clone_obj.notification_inbox_province[0] != 0
      ) {
        clone_obj.notification_is_all_province = false;
      } else {
        clone_obj.notification_is_all_province = true;
      }
      delete clone_obj.notification_inbox_id;
      this.form = clone_obj;
      alert("this notification info will be on send form.");
    },
    async send(send_form) {
      if (this.$refs.form.validate()) {
        let clone_obj = JSON.parse(JSON.stringify(send_form));
        this.is_sending = true;
        if (clone_obj.notification_is_all_province == true) {
          clone_obj.notification_inbox_province = [0];
        }
        delete clone_obj.notification_is_all_province;
        if (
          clone_obj.notification_inbox_html != "" &&
          clone_obj.notification_inbox_html != null
        ) {
          clone_obj.notification_inbox_saved = true;
        } else {
          clone_obj.notification_inbox_saved = false;
        }
        console.log(clone_obj);
        // let check = false;
        let check = await this.$store.dispatch(
          "fetchFoodSetAppBack/sendNotification",
          clone_obj
        );
        if (check == true) {
          this.fetchData();
        }
        this.setForm();
        this.$refs.form.resetValidation();
        this.is_sending = false;
      }
    },
    async fetchData() {
      this.isLoading = true;
      await this.$store.dispatch("fetchFoodSetAppBack/getNotificationList");
      this.isLoading = false;
    },
    reset() {},
  },
  async created() {
    this.setForm();
    this.fetchData();
  },
  destroyed() {
    this.$store.commit("fetchFoodSetAppBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Set notificaltion",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped>
.add-btn {
  top: 42%;
  left: 40%;
}
.filter-close {
  background-color: gray;
  opacity: 0.5;
  transition: 0.5s;
  width: 100%;
  height: 100%;
}
</style>
